import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as productActions from '../../../actionCreators/product';
import PropTypes from 'prop-types';
import './DeliveryOptions.scss';

class DeliveryOptions extends Component {
  static propTypes = {
    productData: PropTypes.object,
  };
  constructor(props) {
    super(props);
    const { dataLocale } = props;
    this.invalidPinCode = false;
    this.invalidPinCodeErrorClass = '';
    this.expressOption = null;
    this.errorText = dataLocale.PLEASE_ENTER_VALID_PINCODE;
    this.state = { inputPincode: '', changePincodeForm: '', estimateDeliverytime: 'hide' };
    this.expressParameter = this.expressParameter.bind(this);
  }

  componentDidUpdate = prevProps => {
    const { successExpress, errorExpress } = this.props;
    const { inputPincode } = this.state;
    if (prevProps.successExpress !== successExpress && successExpress) {
      if (window.dtm.LenskartRewamp)
        window.dtm.LenskartRewamp.Pdp.click.checkAvailability(inputPincode, 'serviceable');
      (() => {
        this.setState({ estimateDeliverytime: '', changePincodeForm: 'hide' });
      })();
    }
    if (prevProps.errorExpress !== errorExpress && errorExpress) {
      if (window.dtm.LenskartRewamp)
        window.dtm.LenskartRewamp.Pdp.click.checkAvailability(inputPincode, 'non-servicable');
      (() => {
        this.setState({ estimateDeliverytime: 'hide', changePincodeForm: '' });
      })();
    }
  };

  changePinHandler = event => {
    this.setState({ inputPincode: event.target.value });
  };

  expressParameter(event) {
    event.preventDefault();
    const { productData, productActions, dataLocale, localeInfo } = this.props;
    const { inputPincode } = this.state;
    const regex = /^[0-9]+$/;
    const countryCode = localeInfo.countryCode || 'in';
    if (
      inputPincode !== '' &&
      regex.test(inputPincode) &&
      inputPincode.length === 6 &&
      productData?.id
    ) {
      productActions.getExpressTime(productData.id, inputPincode, countryCode);
    } else {
      this.invalidPinCode = true;
      this.invalidPinCodeErrorClass = 'error';
      this.errorText = dataLocale.PLEASE_ENTER_VALID_PINCODE;
      this.setState({ changePincodeForm: '', estimateDeliverytime: 'hide' });
    }
  }

  changePincode = () => {
    const { productActions } = this.props;
    productActions.resetPincodeForm();
    this.setState({ changePincodeForm: '', estimateDeliverytime: 'hide' });
  };

  render() {
    const {
      productData,
      successExpress,
      errorExpress,
      expressOptions,
      pdpCheckDeliveryCustom,
      dataLocale,
    } = this.props;
    const { changePincodeForm, estimateDeliverytime, inputPincode } = this.state;
    const price =
      productData.deliveryOptions[0].deliveryOption === 'EXPRESS'
        ? productData.deliveryOptions[0].shipping_Charges.price
        : null;
    if (successExpress && expressOptions?.result?.length) {
      this.invalidPinCode = false;
      this.invalidPinCodeErrorClass = '';
      this.expressOption = expressOptions.result;
    } else if (errorExpress) {
      this.invalidPinCode = true;
      this.invalidPinCodeErrorClass = 'error';
      this.errorText = errorExpress.message;
    }
    const {
      NOT_AVAILABLE_WITH_CASH,
      APPLICABLE_ONLY_CERTAIN_POWERS,
      REFUND_IN_CASE_OF_DELIVERY_DELAY,
      ORDER_PROCESSING_STARTS_AFTER,
      CHECK_DELIVERY_OPTIONS,
      ENTER_PIN_CODE,
      CHECK,
      CHANGE,
      DELIVERY_OPTIONS_TO,
      STANDARD_DELIVERY,
      FREE,
      GET_IT_DELIVERED_BY,
      XPRESS_DELIVERY,
      XPRESS_DELIVERY_DETAILS,
      DELIVERY_LOGO,
    } = dataLocale;
    return (
      <div
        className={` ${
          !pdpCheckDeliveryCustom ? 'deliveryOptions' : 'pdpDeliveryOptions'
        } delivery-option-wrapper`}
      >
        <div className={`express-delivery ${changePincodeForm}`}>
          {!pdpCheckDeliveryCustom && <h3 className="text-uppercase">{CHECK_DELIVERY_OPTIONS}</h3>}
          <form noValidate autoComplete="off" className="check-delivery-status">
            <div className="pdp-check-delivery-wrapper">
              <div className="col-lg-8 col-md-8 col-sm-8 padding-r0 check-pincode-status">
                <input
                  className={this.invalidPinCodeErrorClass}
                  maxLength="6"
                  name="pincode"
                  placeholder={ENTER_PIN_CODE}
                  type="text"
                  value={inputPincode}
                  onChange={this.changePinHandler}
                />
                {this.invalidPinCode ? (
                  <div className="lens-express-error">{this.errorText}</div>
                ) : null}
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4 check-btn padding-r6 fw600">
                <button
                  aria-label="check delivery options"
                  className="text-capitalize"
                  type="submit"
                  onClick={event => this.expressParameter(event)}
                >
                  {CHECK}
                </button>
              </div>
            </div>
          </form>
          {!pdpCheckDeliveryCustom && productData.sellerLabel && productData.sellerLabel !== '' && (
            <p className="inline-block full-width padding-l15 padding-r15 padding-t10 margin-b0 fs11 seller-label">
              {productData.sellerLabel}
            </p>
          )}
        </div>

        <div className={`ex-delivery ${estimateDeliverytime}`}>
          {DELIVERY_OPTIONS_TO} {inputPincode}
          <span></span>{' '}
          <span className="ex-change text-uppercase" onClick={this.changePincode}>
            {CHANGE}
          </span>
        </div>
        {this.expressOption?.length && (
          <ul className={`delivery-estimate ${estimateDeliverytime}`}>
            <li>
              <img
                alt={DELIVERY_LOGO}
                src="//static.lenskart.com/media/desktop/img/pdp/delivery.png"
              />
              <div className="delivery-content">
                <div className="delivery-cont-one">
                  {STANDARD_DELIVERY} <span>({FREE})</span>
                </div>
                <div className="delivery-cont-two">
                  {GET_IT_DELIVERED_BY}{' '}
                  <span>
                    {new Date(this.expressOption[0].deliveryDate).toString().slice(0, 15)}
                  </span>
                </div>
                {productData.sellerLabel &&
                  productData.sellerLabel !== '' &&
                  !pdpCheckDeliveryCustom && (
                    <p className="padding-t10 margin-b0 fs11 seller-label">
                      {productData.sellerLabel}
                    </p>
                  )}
              </div>
            </li>
            {productData.deliveryOptions[0].deliveryOption === 'EXPRESS' &&
            this.expressOptions?.length > 1 ? (
              <li className="express-delivery-cont">
                <img
                  alt={DELIVERY_LOGO}
                  src="//static.lenskart.com/media/desktop/img/pdp/delivery.png"
                />
                <div className="delivery-content">
                  <div className="delivery-cont-one">
                    {XPRESS_DELIVERY} (<i className="fa fa-inr"></i>
                    <b>{price}</b>)
                    <div className="express-condition">
                      <ul className="express-hover">
                        <li>
                          <img
                            alt={DELIVERY_LOGO}
                            src="//static.lenskart.com/media/desktop/img/express-icon.png"
                          />
                          <span>{XPRESS_DELIVERY_DETAILS}</span>
                        </li>
                        <li>{NOT_AVAILABLE_WITH_CASH}</li>
                        <li>{APPLICABLE_ONLY_CERTAIN_POWERS}</li>
                        <li>{ORDER_PROCESSING_STARTS_AFTER}</li>
                        <li>{REFUND_IN_CASE_OF_DELIVERY_DELAY}</li>
                      </ul>
                    </div>
                  </div>
                  <div className="delivery-cont-two">
                    {GET_IT_DELIVERED_BY}{' '}
                    <span>
                      {new Date(this.expressOption[1].deliveryDate).toString().slice(0, 15)}
                    </span>
                  </div>
                  {productData.sellerLabel && productData.sellerLabel !== '' && (
                    <p className="inline-block full-width padding-l15 padding-r15 padding-t15 margin-b0 fs11 seller-label">
                      {productData.sellerLabel}
                    </p>
                  )}
                </div>
              </li>
            ) : null}
          </ul>
        )}
        {productData.lastPurchaseInfo && (
          <div className="col-lg-12 col-md-12 col-sm-12 margin-t10 last-purchase">
            {productData.lastPurchaseInfo}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  successExpress: state.product.successExpress,
  errorExpress: state.product.errorExpress,
  expressOptions: state.product.expressOptions,
  selectedPowerType: state.product.selectedPowerType,
  dataLocale: state.locale,
  localeInfo: state.common.localeInfo,
});

function mapDispatchToProps(dispatch) {
  return {
    productActions: bindActionCreators(productActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryOptions);
